import $ from 'jquery';

class RoostHomeSlider {
    constructor() {
        this.scrollSpeed = 3000;
        this.maxBannerHeight = 500;

        this.resizeBanner();
        this.slides = $(".homeslides .homeslide-slide");
        this.addArrows();
        this.addDots();
        this.addPause();
        this.slideIndex = -1;
        this.dots = $('.homeslides .dot');
        this.showSlides(1);
        this.isSliding = true;
        this.setIntervalIfSliding();
        this.events();
    }

    events() {
        this.dots.on('click', e => this.currentSlide(e));
        $(".next").on("click", () => this.plusSlides(1));
        $(".prev").on("click", () => this.plusSlides(-1));
        $(window).resize(this.resizeBanner);
        $(".homeslides .pause-play").on("click", "a.pause", () => this.stopSlider());
        $(".homeslides .pause-play").on("click", "a.play", () => this.startSlider());
    }

    // other methods

    addDots() {
        $('.homeslides').append('<div class="image-dots">');
        var dots = $('.homeslides .image-dots');
        var i;
        for (i = 0; i < this.slides.length; i++) {
            dots.append('<span class="dot" data-slide="' + (i+1) + '"></span>');
        }
    }

    addPause() {
        $('.homeslides').append('<div class="pause-play">');
        $('.pause-play').append('<a class="pause"><i class="las la-pause"></i></a>');
    }

    addArrows() {
        $('.homeslides').append('<a class="prev">&#10094;</a>');
        $('.homeslides').append('<a class="next">&#10095;</a>');
    }

    autoScroll() {
        this.plusSlides(1);
    }

    plusSlides(n) {
        clearInterval(this.intervalHandler);
        this.setIntervalIfSliding();
        this.showSlides(this.slideIndex + n);
    }

    showSlides(n) {
      if (n > this.slides.length) {n = 1}
      if (n < 1) {n = this.slides.length}
      if (this.slideIndex > 0) {
          $(this.slides[this.slideIndex-1]).fadeOut();
          $(this.dots[this.slideIndex-1]).removeClass('active');
      }

      this.slideIndex = n;
      $(this.slides[this.slideIndex-1]).fadeIn();
      $(this.dots[this.slideIndex-1]).addClass('active');
    }

    currentSlide(e) {
        clearInterval(this.intervalHandler);
        this.setIntervalIfSliding();
        var n = parseInt(e.target.getAttribute('data-slide'));
        this.showSlides(n);
    }

    resizeBanner() {
        $('.homeslides').css('height', Math.min(this.maxBannerHeight, (window.innerWidth * 1080 / 1920)) + "px");
    }


    stopSlider() {
        clearInterval(this.intervalHandler);
        this.isSliding = false;
        $(".pause-play .pause")
            .removeClass("pause")
            .addClass("play")
            .html('<i class="las la-play"></i>');
    }

    startSlider() {
        clearInterval(this.intervalHandler);
        this.isSliding = true;
        $(".pause-play .play")
            .removeClass("play")
            .addClass("pause")
            .html('<i class="las la-pause"></i>');
        this.plusSlides(1);
    }

    setIntervalIfSliding() {
        if (this.isSliding) {
            this.intervalHandler = setInterval(this.autoScroll.bind(this), this.scrollSpeed);
        }
    }
}

export default RoostHomeSlider;
